<form>
  <div class="form-group">
    <label for="password">{{ passwordLabel }}</label>
    <input
      type="password"
      name="password"
      class="form-control"
      [formControl]="f.password"
      maxlength="64"
      autocomplete="new-password"
    />

    <div class="strength-meter">
      <div class="strength-meter-fill" [attr.data-strength]="passwordEval?.score"></div>
    </div>
    @if (isFieldInvalid('password', "passwordWeak")) {
      <mat-error>Password is too weak</mat-error>
    }
    <div class="password-help">
      @if (passwordEval != null && f.password.value.length > 0) {
        @if (passwordEval.warning) {
          <p class="password-feedback">{{ fixSentence(passwordEval.warning) }}</p>
        }
        @if (passwordEval.suggestions?.length > 0 && passwordEval.score < 3) {
          <p>
            @for (suggestion of passwordEval.suggestions; track suggestion) {
              <span class="password-suggetion">{{ fixSentence(suggestion) }}&nbsp;</span>
            }
          </p>
        }
      }
      <p>Must be at least 8 characters long. Spaces are allowed.</p>
    </div>
  </div>

  <div class="form-group">
    <label for="password-confirmation">{{ passwordConfirmationLabel }}</label>
    <input
      type="password"
      name="password-confirmation"
      class="form-control"
      [formControl]="f.passwordConfirmation"
      maxlength="64"
      autocomplete="new-password"
    />

    @if (isFieldInvalid('passwordConfirmation', "passwordMismatch")) {
      <mat-error>The passwords you entered do not match</mat-error>
    }
  </div>
</form>
